export interface BankCardInfo {
  card: string;
  name: string;
}

export interface BankCardsMap {
  [key: string]: BankCardInfo;
}

export interface CardInfo {
  card_number: string;
  iban: string;
  title: string;
}

export interface CardListItem {
  id: number;
  card_number: string;
  iban: string;
  title: string;
  status: string;
}

export const bankCards: BankCardsMap = {
  "627760": { card: "post-bank.jpg", name: "پست بانک" },
  "627648": { card: "tosee-taavon.jpg", name: "بانک توسعه تعاون" },
  "627593": { card: "iran-zamin.jpg", name: "بانک ایران زمین" },
  "505785": { card: "iran-zamin.jpg", name: "بانک ایران زمین" },
  "627381": { card: "ansar.jpg", name: "بانک انصار" },
  "627412": { card: "eqtesad-novin.jpg", name: "بانک اقتصاد نوین" },
  "622106": { card: "parsian.jpg", name: "بانک پارسیان" },
  "627884": { card: "parsian.jpg", name: "بانک پارسیان" },
  "639607": { card: "sanat-madan.jpg", name: "بانک صنعت و معدن" },
  "505416": { card: "gardeshgari.jpg", name: "بانک گردشگری" },
  "621986": { card: "saman.jpg", name: "بانک سامان" },
  "639370": { card: "mehregan.jpg", name: "بانک مهر اقتصاد" },
  "627353": { card: "tejarat.jpg", name: "بانک تجارت" },
  "589210": { card: "sepah.jpg", name: "بانک سپه" },
  "603799": { card: "melli.jpg", name: "بانک ملی ایران" },
  "627961": { card: "saderat.jpg", name: "بانک صادرات ایران" },
  "603770": { card: "keshavarzi.jpg", name: "بانک کشاورزی" },
  "628023": { card: "maskan.jpg", name: "بانک مسکن" },
  "585983": { card: "tamavon-iran.jpg", name: "بانک توسعه صادرات" },
  "589463": { card: "refah.jpg", name: "بانک رفاه کارگران" },
  "627488": { card: "karafarin.jpg", name: "بانک کارآفرین" },
  "639346": { card: "sina.jpg", name: "بانک سینا" },
  "502938": { card: "dey.jpg", name: "بانک دی" },
  "639347": { card: "pasargad.jpg", name: "بانک پاسارگاد" },
};

export const formatCardNumber = (cardNumber: string): string => {
  if (!cardNumber) return "";

  const cleaned = cardNumber.replace(/\D/g, "").slice(0, 16);
  const chunks: string[] = [];

  for (let i = 0; i < cleaned.length; i += 4) {
    chunks.push(cleaned.slice(i, i + 4));
  }

  return chunks.join(" ");
};

export const getBankInfo = (cardNumber: string): BankCardInfo | null => {
  if (!cardNumber) return null;

  const firstSix = cardNumber.slice(0, 6);
  return bankCards[firstSix] || null;
};
